document.addEventListener('DOMContentLoaded', function () {
    waitForElement();
    
    function waitForElement(maxRetries = 10, retryInterval = 2000) {
        var routineSections = document.querySelectorAll('[data-section-products-id]');
        var retryCount = 0;
    
        function checkElements() {
            var allInitialized = true;
    
            routineSections.forEach(function (section) {
                var id = '.mm-products-splide';
                var splideElem = section.querySelector(id);
    
                if (splideElem != null && splideElem.querySelectorAll(".splide__slide").length > 0) {
                    mmSplideInit(splideElem, section);
                } else {
                    allInitialized = false; // Indique qu'au moins un élément n'est pas prêt
                }
            });
    
            if (!allInitialized) {
                retryCount++;
                if (retryCount < maxRetries) {
                    setTimeout(checkElements, retryInterval);
                } else {
                    console.warn("Max retries reached. Some elements may not have been initialized.");
                }
            }
        }
    
        checkElements();
    }


    function mmSplideInit(splideElem, section) {
        // Initialisation du compteur de défilement
        let scrollCounter = 0;
        
        const slides = splideElem.querySelectorAll('.splide__slide');
        slides.forEach((slide, index) => {
            if (index >= 10) slide.remove();
        });

        function resetVisibleClass(splideElem) {
            const slides = splideElem.querySelectorAll('.splide__slide');
            
            // Supprime `is-visible` de toutes les diapositives
            slides.forEach(slide => slide.classList.remove('is-active'));
            
            // Ajoute `is-visible` uniquement à la première diapositive
            if (slides.length > 0) {
                slides[0].classList.add('is-active');
            }
        }
    
        // Appeler la fonction avant d'initialiser Splide
        resetVisibleClass(splideElem);

        var splideInstance = new Splide(splideElem, {
            type        : 'slide',
            arrows      : true,
            pagination  : false,
            gap         : '20px',
            snap		: true,
			speed 		: '1000',
            fixedWidth  : '210px',
            perMove     : 1,
            omitEnd     : true,
            padding     : {
                left: '50px', 
                right: '50px'
            },
            breakpoints : {
                768: {
                    gap             : '10px',
                    padding         : {
                        left: '15px', 
                        right: '15px' 
                    }
                }
            }
        }).mount();

        // Ajout de la fonction de mise à jour de la barre de progression
        var bar = section.querySelector('.my-carousel-progress .my-carousel-progress-bar');

        function updateProgressBar() {
            var end = splideInstance.Components.Controller.getEnd() + 1; // Nombre total de slides
            var rate = Math.min((splideInstance.index + 1) / end, 1); // Calcul du ratio
            if (bar) {
                bar.style.width = String(100 * rate) + '%';
            }
        }

        // Mise à jour initiale
        updateProgressBar();

        // Mise à jour lors des mouvements ou drag du carrousel
        splideInstance.on('moved', updateProgressBar);
        splideInstance.on('dragged', updateProgressBar);

        // Ajoute l'écouteur d'événement de défilement à splideElem
        splideElem.addEventListener('wheel', function (e) {
            // Ne pas empêcher le comportement par défaut si le défilement est vertical
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                return;
            }

            // Empêche le comportement par défaut uniquement pour le défilement horizontal
            e.preventDefault();

            // Incrémente le compteur de défilements
            scrollCounter++;

            // Vérifie si le compteur atteint le seuil pour un mouvement
            if (scrollCounter >= 12) {
                // Réinitialise le compteur
                scrollCounter = 0;

                // Déplace la diapositive selon la direction du défilement horizontal
                if (e.deltaX < 0) {
                    splideInstance.go('<'); // Mouvement vers la gauche
                } else if (e.deltaX > 0) {
                    splideInstance.go('>'); // Mouvement vers la droite
                }
            }
        });
    }
});
